// extracted by mini-css-extract-plugin
export var radio = "radio-module--radio--1Ol4v";
export var label = "radio-module--label--2-nEO";